/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from '@hookform/error-message';
import {
  HrInputText,
  HrInputTextWithSymbol,
  HrLabel,
  HrFlexContainer,
  HrRed,
  HrParagraph,
  HrInputPassword
} from '@components/styles/hr-styles';
import { get } from 'lodash';
import { DisplaySettingsContext } from '../../../postulation_form/store/display-settings';
import '../../styles/estilos.css'
export function Input({
  name,
  type,
  validate,
  formState,
  register,
  symbol,
  disabled,
  title,
  placeholder,
  errorPosition,
  handlerOnBlur,
  handlerOnPaste
}) {
  const validateRegister = {};
  const { errors } = formState;
  const [t] = useTranslation();
  const refCurrent = useRef(null);
  const err = get(errors, name);
  useEffect(() => {
    const firstError = Object.keys(errors).reduce((field, a) => {
      return !!errors[field] ? field : a;
    }, null);
    const splitName = name.split('.');
    const nameError = splitName.length > 1 ? splitName[0] : name;
    if (firstError === nameError) {
      refCurrent.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      refCurrent.current?.focus();
    }
  }, [err]);
  // #region validacion

  if (validate.validateEmail) {
    validateRegister.validate = validate.validateEmail;
  }

  if (validate.required) {
    validateRegister.required = 'Campo obligatorio';
  }

  if (validate.maxLength > 0) {
    validateRegister.maxLength = { value: validate.maxLength, message: `Máximo ${validate.maxLength} caracteres` };
  }

  if (validate.minLength > 0) {
    validateRegister.minLength = { value: validate.minLength, message: `Mínimo ${validate.minLength} caracteres` };
  }

  if (validate.whiteSpace) {
    validateRegister.pattern = {
      // value: /^[^\s]+(?:$|*[^\s]+$)/,
      value: /^(?!\s)/,
      message: 'No ingresar espacios en blanco.'
    };
  }

  if (validate.caracterSpecial) {
    validateRegister.validate = {
      caracterSpecial: (value) => !/[*$^[\]{};'"\\|<>]+/.test(value) || 'El título posee caracteres inválidos'
    };
  }

  if (validate.caracterNoNumerics) {
    validateRegister.validate = {
      caracterSpecial: (value) => {
        if (value === '' && !validate.required) {
          return true;
        }

        return /^[a-zA-Z âáéíóúäëïöüÁÉÍÓÚÑñ]+$/.test(value) || 'El campo posee caracteres inválidos';
      }
    };
  }

  if (validate.caracterSpecialNew) {
    validateRegister.validate = {
      caracterSpecial: (value) =>
        !/[!@#$%^*_+=\[\]{};':"\\|,.<>\/?]+/.test(value) || 'El campo posee caracteres inválidos'
    };
  }

  if (validate.mail) {
    validateRegister.pattern = {
      value: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
      message: t('general.error.invalid_email')
      // si esa expresion regular no funciona, probar con
      // ^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$
    };
  }

  if (validate.urlYoutube) {
    validateRegister.pattern = {
      // value: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/,
      value: /^(https?\:\/\/)?(www\.youtube\.com|youtu\.be)\/.+$/,
      message: 'URL incorrecta'
    };
  }

  if (validate.urlVimeo) {
    validateRegister.pattern = {
      value: /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/,
      message: 'URL incorrecta'
    };
  }

  if (validate.urlLinkedin) {
    validateRegister.pattern = {
      value: /^(https:\/\/)?(www\.)?linkedin\.com\/in\/([\p{L}0-9-]|%[0-9A-Fa-f]{2})+\/?$/iu,
      message: 'Ingrese una URL válida'
    };
  }

  if (validate.min) {
    validateRegister.min = { value: validate.min, message: `El valor mínimo debe ser de: ${validate.min}.` };
  }

  if (validate.max) {
    validateRegister.max = { value: validate.max, message: `El valor maximo debe ser de: ${validate.max}.` };
  }

  if (validate.valueAsNumber) {
    validateRegister.valueAsNumber = validate.valueAsNumber;
  }


  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);
  // #endregion validacion
  return (
    <HrFlexContainer flexDirection='column' gap='8px' alignItems='flex-start' ref={refCurrent}>
      {title && (
        <HrFlexContainer justifyContent='space-between'>
          <HrLabel fontSizeSetting={fontSizeSetting} htmlFor={name} isRequired={validate.required} userSelect='none' color={darkMode ? 'white' : ''}>
            {title}
          </HrLabel>
          {errorPosition === 'top' && err && (
            <ErrorMessage
              errors={errors}
              name={name}
              render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
            />
          )}
        </HrFlexContainer>
      )}
      {symbol ? (
        <HrInputTextWithSymbol background={darkMode ? 'transparent' : ''} color={darkMode ? 'white' : ''} className={`${errors[name] ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
          {symbol}
          <input
            id={name}
            name={name}
            type={type}
            placeholder={placeholder}
            {...register(name, validateRegister)}
            disabled={disabled}
            onBlur={(e) => {
              e.target.value = e.target.value.trim();
              handlerOnBlur(e);
            }}
            onPaste={(e) => handlerOnPaste(e)}
          />
        </HrInputTextWithSymbol>
      ) : (
        <HrInputText
          id={name}
          name={name}
          type={type}
          border={darkMode ? 'white' : ''}
          background={darkMode ? 'transparent' : ''} 
          color={darkMode ? 'white' : ''}
          backgroundDisabled={darkMode ? '#3c3c54' : ''} 
          placeholder={placeholder}
          fontSizeSetting={fontSizeSetting}
          {...register(name, validateRegister)}
          disabled={disabled}
          className={get(errors, name) ? 'error' : ''}
          onBlur={(e) => {
            e.target.value = e.target.value.trim();
            handlerOnBlur(e);
          }}
          onPaste={(e) => handlerOnPaste(e)}
        />
      )}
      {errorPosition === 'bottom' && get(errors, name) && (
        <HrFlexContainer justifyContent='flex-end'>
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
          />
        </HrFlexContainer>
      )}
    </HrFlexContainer>
  );
}

Input.propTypes = {
  // TODO:revisar caso de uso con el tipo number y value
  type: PropTypes.oneOf(['text', 'email', 'tel', 'number', 'date', 'password']),
  name: PropTypes.string,
  value: PropTypes.string,
  validate: PropTypes.object,
  errorPosition: PropTypes.oneOf(['top', 'bottom']),
  handlerOnBlur: PropTypes.func,
  handlerOnPaste: PropTypes.func
};

Input.defaultProps = {
  type: 'text',
  name: '',
  value: '',
  validate: {},
  errorPosition: 'top',
  handlerOnBlur: () => {},
  handlerOnPaste: () => {}
};

export const InputPassword = ({ name, validate, formState, register, disabled, title, placeholder }) => {
  const [viewPassword, setViewPassword] = useState(false);
  const validateRegister = {};
  const { errors } = formState;
  const [t] = useTranslation();

  if (validate.required) {
    validateRegister.required = 'Campo obligatorio';
  }
  if (validate.maxLength > 0) {
    validateRegister.maxLength = { value: validate.maxLength, message: `Máximo ${validate.maxLength} caracteres` };
  }
  if (validate.minLength > 0) {
    validateRegister.minLength = { value: validate.minLength, message: `Mínimo ${validate.minLength} caracteres` };
  }
  if (validate.whiteSpace) {
    validateRegister.pattern = {
      // value: /^[^\s]+(?:$|.*[^\s]+$)/,
      value: /^(?!\s)/,
      message: 'No ingresar espacios en blanco.'
    };
  }
  if (validate.mail) {
    validateRegister.pattern = {
      value: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
      message: t('general.error.invalid_email')
      // si esa expresion regular no funciona, probar con
      // ^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$
    };
  }
  if (validate.urlYoutube) {
    validateRegister.pattern = {
      // value: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/,
      value: /^(https?\:\/\/)?(www\.youtube\.com|youtu\.be)\/.+$/,
      message: 'URL incorrecta'
    };
  }
  if (validate.urlVimeo) {
    validateRegister.pattern = {
      value: /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/,
      message: 'URL incorrecta'
    };
  }
  if (validate.min) {
    validateRegister.min = { value: validate.min, message: `El valor mínimo debe ser de: ${validate.min}.` };
  }
  if (validate.max) {
    validateRegister.max = { value: validate.max, message: `El valor maximo debe ser de: ${validate.max}.` };
  }
  if (validate.valueAsNumber) {
    validateRegister.valueAsNumber = validate.valueAsNumber;
  }

  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <HrFlexContainer flexDirection='column' gap='8px' alignItems='flex-end'>
      {title && (
        <HrFlexContainer justifyContent='space-between'>
          <HrLabel fontSizeSetting={fontSizeSetting} htmlFor={name} isRequired={validate.required} userSelect='none' color={darkMode ? 'white' : ''}>
            {title}
          </HrLabel>
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
          />
        </HrFlexContainer>
      )}
      <HrFlexContainer>
        <HrInputPassword fontSizeSetting={fontSizeSetting} backgroundColor={darkMode ? 'transparent' : ''} className={`${errors[name] ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
          <input
            id={name}
            name={name}
            type={viewPassword ? 'text' : 'password'}
            placeholder={placeholder}
            className={errors[name] ? 'error' : ''}
            {...register(name, validateRegister)}
            disabled={disabled}
            style={{ backgroundColor: darkMode ? 'transparent' : '' , color: darkMode ? '#fff' : '' }}
          />
          <span
            className={viewPassword ? 'hr-Eye-off' : 'hr-Eye-open'}
            onClick={() => {
              setViewPassword(!viewPassword);
            }}
            onKeyPress={() => {
              setViewPassword(!viewPassword);
            }}
            role='button'
            aria-label='Show Password'
            tabIndex={0}
            style={{ color: darkMode ? '#fff' : '' }}
          />
        </HrInputPassword>
      </HrFlexContainer>
      {!title && (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
        />
      )}
    </HrFlexContainer>
  );
};
